
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_47_1785)"}},[_c('path',{attrs:{"d":"M28 0H2.544v32H28V0z","fill":"#F15A24"}}),_c('path',{attrs:{"d":"M3.818 1.392H0v2.782h3.818V1.392zM3.818 6.955H0v2.782h3.818V6.955zM3.818 12.521H0v2.781h3.818v-2.781zM3.818 18.087H0v2.781h3.818v-2.781zM3.818 23.653H0v2.781h3.818v-2.781zM3.818 29.216H0v2.781h3.818v-2.781z","fill":"#999"}}),_c('path',{attrs:{"d":"M24.182 5.566H6.362v8.347h17.82V5.566z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_47_1785"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h28v32H0z"}})])])])
          )
        }
      }
    